export * from './property-info-input-adapter';
